import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { divider, primary } from '../../Styles/Colours';
import styles from './CreatingMedicationListPlaceholder.module.css';
import CreatingMedicationListGraphic from '../../Images/creating-medication-list.svg';
var ColorLinearProgress = withStyles({
    colorPrimary: {
        backgroundColor: divider
    },
    barColorPrimary: {
        backgroundColor: primary
    }
})(LinearProgress);
export var CreatingMedicationListPlaceholder = function () {
    return (React.createElement("div", { className: styles.body },
        React.createElement("img", { src: CreatingMedicationListGraphic, alt: '', className: styles.main }),
        React.createElement("div", { className: styles.title },
            "Creating your ",
            React.createElement("em", null, "medication list")),
        React.createElement("div", { className: styles.info }, "We're creating your medication list"),
        React.createElement(ColorLinearProgress, { className: styles.progress })));
};
